import { render, staticRenderFns } from "./coursePlans.vue?vue&type=template&id=43767992"
import script from "./coursePlans.vue?vue&type=script&lang=js"
export * from "./coursePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports